import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableTruncate from '@/components/datatable/DataTableTruncate.vue';
import UserGroupTableActions from '@/components/user-groups/UserGroupTableActions.vue';
import type { UserGroup } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<UserGroup>[] = [
    {
        accessorKey: 'id',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.id',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.name',
            }),
    },
    {
        accessorKey: 'users_names',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.employees',
            }),

        cell: ({ row }) => {
            return h(DataTableTruncate, {
                value: row.original.users_names,
            });
        },
    },
    {
        accessorKey: 'users_count',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.user_companies_table.count',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(UserGroupTableActions, {
                userGroup: row.original,
            });
        },
    },
];
